"use strict";

module.exports = function (column) {
  return 'vf__' + column.split('.').join('@@@');
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/get-column-name.js
// module id = 1589
// module chunks = 64